import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticateserviceService } from '../../_service/authenticateservice.service';
import { Router } from '@angular/router';
import { encrypt } from 'src/app/utils/encryptHelper';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['../verify-phone/verify-phone.component.css']
})
export class RegistrationComponent implements OnInit {
  formGroup: FormGroup;
  imageUrl: string | ArrayBuffer = '../../../assets/img/profile_avatar.png';
  file:any
  userHandleError:boolean;
  constructor(private fb: FormBuilder,
    private authService: AuthenticateserviceService, private router:Router, private dialogRef:MatDialogRef<RegistrationComponent>) { }


  ngOnInit(): void {
    this.formGroup = this.fb.group({
      userHandle: ['', Validators.required],
      screenName: ['', Validators.required],
      about: ['']
    });
  }


  uploadFile(event) {
    let reader = new FileReader(); // HTML5 FileReader API
   this.file = event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      reader.readAsDataURL(this.file);


      // When file uploads set it to file formcontrol
      reader.onload = () => {
        this.imageUrl = reader.result;
      }
    }
  }


  onKeyUp(event: KeyboardEvent) {
    const pattern = /[0-9\\+\-\\ ]/g;
    if (!pattern.test(event.key) && event.key !== 'Backspace') {
      event.preventDefault();
      return false;
    }
    return true;
  }


  get f() {
    return this.formGroup.controls;
  }
  onSubmit(){
    if(!this.formGroup.value.userHandle){
      this.userHandleError = true;
      return;
    }
else{
  this.userHandleError=false;
}
    const requestObj = {
      phone_number: localStorage.getItem('new_number'),
      user_name: `@${this.formGroup.value.userHandle}`,
      screen_name: this.formGroup.value.screenName,
      about: this.formGroup.value.about,
      fb_token_id: localStorage.getItem('fb_token'),
      fb_user_id: localStorage.getItem('fb_user_id'),
      device_id: Math.random().toString(36).slice(2)
    }
    this.authService.registerNewUser(requestObj).subscribe( (res) => {
      console.log("insinde component for resgiter", res);
      if(this.file){
      const formData = new FormData(); 
        
      // Store form name as "file" with file data
      formData.append("photo", this.file);
      formData.append('tqr_user_id', localStorage.getItem('userId'));
      // const requestBody = {
      //   tqr_user_id: localStorage.getItem('userId'),
      //   photo: this.imageUrl
      // }
      this.authService.uploadUserProfileImage(formData).subscribe( res => {
        console.log("image upload success", res);
        
      })
    }
    localStorage.setItem('contact', encrypt(requestObj.phone_number));
    localStorage.removeItem('new_number');
    localStorage.removeItem('fb_user_id');
    localStorage.removeItem('fb_token');
    this.dialogRef.close();
    this.router.navigate(["/tqr/cc_prime"]);
    },
    (err)=> {
      console.log("insinde erir block component for register", err);
    })
  }



}
